import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite, CgFileDocument } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";

function ProjectCards(props) {
  const { title, description, techStack, githubLink, deployedLink, deployedLinkType } = props.project;

  // Map project title to image filename (lowercase, underscores, .png)
  const imageMap = {
    "FinBoard - Finance Dashboard": require("../../Assets/Projects/finboard.png"),
    "Antrea Packet Capture Controller": require("../../Assets/Projects/antrea_capture.png"),
    "DialGuard - Phone Directory and Spam Detection System": require("../../Assets/Projects/dialguard.png"),
    "VoteOn: Decentralized Ethereum Voting System": require("../../Assets/Projects/voteon.png"),
    "Expenzo: Full-Stack Expense Tracker": require("../../Assets/Projects/expenzo.png"),
    "DocuAI: Local & Private Chat with Documents": require("../../Assets/Projects/docuai.png"),
    "Trackilo: Job Application Tracking System": require("../../Assets/Projects/trackilo.png"),
    "AI-Powered Ship Management System": require("../../Assets/Projects/ship_management.png"),
    "Event Management System": require("../../Assets/Projects/event_management.png"),
    "Brake-by-Wire System Failure Prediction ML Model": require("../../Assets/Projects/brake_prediction.png"),
    "Chapter Performance Dashboard API": require("../../Assets/Projects/chapter_performance.png"),
    "Stoxify": require("../../Assets/Projects/stoxify.png"),
    "Data Alchemist": require("../../Assets/Projects/data-alchemist.png"),
    "TaskPilot AI: AI that pilots your computer tasks": require("../../Assets/Projects/taskPilot-AI.png"),
    "MarketPulse Monitor - E-commerce Price Monitoring Dashboard": require("../../Assets/Projects/marketpulsemonitor.png"),
    "Seller Performance Analytics Dashboard": require("../../Assets/Projects/sellerscope.png"),
    "Customer Business Analysis Dashboard": require("../../Assets/Projects/insightstream.png"),
    "Evently - Enterprise Event Management Platform": require("../../Assets/Projects/evently.png"),
    "RefNet-Engine - Referral Network System": require("../../Assets/Projects/Refnet.png"),
    "MGNREGA Dashboard - Our Voice, Our Rights": require("../../Assets/Projects/mgnrega.png"),
    "Branch CS Messaging Web Application": require("../../Assets/Projects/branch_messaging.png")
  };
  const projectImage = imageMap[title];

  return (
    <Card className="project-card-view glass-card h-100" style={{ textAlign: "left" }}>
      {projectImage && (
        <Card.Img variant="top" src={projectImage} alt={title + " landing page"} className="blog-img" />
      )}
      <Card.Body className="d-flex flex-column">
        <Card.Title className="project-title purple" style={{ fontSize: "1.4rem", fontWeight: "bold", marginBottom: "0.75rem" }}>{title}</Card.Title>
        <Card.Text className="project-description" style={{ fontSize: "0.95rem", marginBottom: "1rem", flexGrow: 1 }}>
          {description}
        </Card.Text>
        
        <div className="tech-stack-container mb-3">
          {techStack && techStack.map((tech, index) => (
            <span key={index} className="tech-tag">
              {tech}
            </span>
          ))}
        </div>

        <div className="mt-auto d-flex justify-content-start">
          {/* Conditional GitHub Button */}
          {(
            title === "FinBoard - Finance Dashboard" || 
            title === "Antrea Packet Capture Controller" || 
            title === "DialGuard - Phone Directory and Spam Detection System" ||
            title === "VoteOn: Decentralized Ethereum Voting System" || 
            title === "TaskPilot AI: AI that pilots your computer tasks" || 
            title === "RefNet-Engine - Referral Network System" || 
            title === "Branch CS Messaging Web Application"
          ) && githubLink && (
            <Button
              variant="outline-primary"
              href={githubLink}
              target="_blank"
              className="project-button"
              style={{ marginRight: "10px" }}
            >
              <BsGithub /> &nbsp; GitHub
            </Button>
          )}
          {deployedLink && (
            <Button 
              variant="primary" 
              href={deployedLink} 
              target="_blank" 
              className="project-button"
            >
              {deployedLinkType === "docs" ? <CgFileDocument /> : <CgWebsite />} &nbsp;
              {deployedLinkType === "docs" ? "Docs" : "Live Demo"}
            </Button>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
